<div class="respond-form">
  <div class="field-row">
    <label>Review ID:</label>
    <span>{{reviewId}}</span>
  </div>
  <div class="field-row">
    <label>Property ID:</label>
    <span>{{shortTermRentalId}}</span>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="field-row" style="margin-top: 15px;">
      <label>Locale:</label>
      <p-dropdown [options]="localeOptions" formControlName="locale"
        optionLabel="label" optionValue="value" [style]="{'width': '200px'}">
      </p-dropdown>
    </div>

    <div class="field-row" style="margin-top: 10px;">
      <label>Response Text: <span style="color: red;">*</span></label>
      <textarea pInputTextarea formControlName="responseText" rows="8"
        style="width: 100%; max-width: 500px;"
      placeholder="Enter your management response..."></textarea>
    </div>
    @if (form.get('responseText').invalid && form.get('responseText').touched) {
      <div class="validation-error">
        Response text is required (minimum 10 characters).
      </div>
    }

    <div class="actions" style="margin-top: 20px;">
      <button pButton pRipple type="submit" class="p-button-info" label="Submit Response"
      [loading]="submitting" style="margin-right: 10px;"></button>
      <button pButton pRipple type="button" class="p-button-secondary" label="Cancel"
      (click)="cancel()"></button>
    </div>
  </form>
</div>
